import { type MemberRole } from '@prisma/client'

/**
 * Display names for OrganizationMember roles.
 *
 * Lived in four places (team settings, the signup invite banner, the join step
 * and the org-less onboarding screen) until they were pulled together here, so
 * adding a role means touching one file.
 *
 * Keyed by the Prisma enum: a role without a label, or a lookup with anything
 * that is not a role, does not compile.
 */
export const RoleLabels: Record<MemberRole, string> = {
	OWNER: 'Propriétaire',
	ADMIN: 'Administrateur',
	MEMBER: 'Membre',
	VIEWER: 'Lecteur',
}

/**
 * The same labels lowercased, for mid-sentence use ("en tant que membre").
 * Derived rather than written out twice so the two sets cannot drift apart.
 */
export const RoleLabelsInline = Object.fromEntries(
	Object.entries(RoleLabels).map(([role, label]) => [
		role,
		label.toLowerCase(),
	]),
) as Record<MemberRole, string>
